import { render, staticRenderFns } from "./DeadlineMonitoringTabApprovals.vue?vue&type=template&id=37ac3482"
import script from "./DeadlineMonitoringTabApprovals.vue?vue&type=script&lang=js"
export * from "./DeadlineMonitoringTabApprovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports